import { UitkPageLoader } from 'uitk-react-loader';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { defaultConfig } from '@eg-maps/core';
import * as React from 'react';
import { initMapBoxApi, initGoogleMapsApi } from 'uitk-react-utils';
import '../types/uitk-eg-map-marker-type.esm.js';
import { UitkEGMapsType } from '../types/uitk-eg-map-props.esm.js';

/* eslint-disable react-hooks/exhaustive-deps */
var useIsMounted = function () {
  var isMounted = React.useRef(false);
  React.useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};
var UitkEGMapsScriptLoader = function (_a) {
  var width = _a.width,
    height = _a.height,
    mapType = _a.mapType,
    mapTypeVersion = _a.mapTypeVersion,
    accessToken = _a.accessToken,
    children = _a.children,
    locale = _a.locale,
    googleMapsId = _a.googleMapsId,
    _b = _a.reloadMapProviderSDK,
    reloadMapProviderSDK = _b === void 0 ? false : _b,
    onError = _a.onError;
  var isMounted = useIsMounted();
  var _c = React.useState(1),
    loadingCount = _c[0],
    setLoadingCount = _c[1];
  var _d = React.useState(),
    error = _d[0],
    setError = _d[1];
  var egMapsConfig = defaultConfig();
  React.useEffect(function () {
    var _a, _b;
    var timeoutDuration = 10000;
    var timeoutPromise = new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error('Timeout: Map API initialization took too long'));
      }, timeoutDuration);
    });
    switch (mapType) {
      case UitkEGMapsType.GOOGLE:
        {
          var baseUrl = (_b = (_a = egMapsConfig.googleMaps) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.api;
          if (baseUrl) {
            var conf = {
              accessToken: accessToken,
              mapId: googleMapsId,
              locale: locale,
              version: mapTypeVersion
            };
            Promise.race([initGoogleMapsApi(reloadMapProviderSDK, conf, false), timeoutPromise]).then(function () {
              if (isMounted.current) {
                setLoadingCount(0);
              }
            }).catch(function (err) {
              setError(err.message);
              if (typeof onError === 'function') onError(err);
            });
          } else {
            var err = {
              message: 'No base URL found in eg-maps config to load google maps sdk'
            };
            setError(err.message);
            if (typeof onError === 'function') onError(err);
          }
        }
        break;
      case UitkEGMapsType.MAPBOX:
        {
          var conf = {
            version: mapTypeVersion
          };
          Promise.race([initMapBoxApi(reloadMapProviderSDK, conf), timeoutPromise]).then(function () {
            if (isMounted.current) {
              setLoadingCount(0);
            }
          }).catch(function (err) {
            setError(err.message);
            if (typeof onError === 'function') onError(err);
          });
        }
        break;
      default:
        {
          var err = {
            message: "Map provider not supported: ".concat(mapType)
          };
          setError(err.message);
          if (typeof onError === 'function') onError(err);
        }
    }
  }, []);
  if (loadingCount > 0 && !error) {
    return React.createElement("div", {
      style: {
        width: width,
        height: height
      }
    }, React.createElement(UitkLayoutPosition, {
      type: "relative",
      position: {
        top: 'center',
        left: 'center'
      }
    }, React.createElement(UitkPageLoader, {
      visible: true,
      className: "uitk-eg-maps-page-loader"
    })));
  }
  return React.createElement(React.Fragment, null, children);
};
export { UitkEGMapsScriptLoader, useIsMounted };